module.exports = __webpack_public_path__ + "img/pl5daily_icon.a0839e36.png";